import Vue from 'vue';
import '@isyscore/styles';

import store from './store';
import Desk from './views/desk';
import './plugins/base-ui';
import './plugins/admin-ui';
import './plugins/svg-icon';
import './plugins/event-bus';
import AppManager from './store/modules/app-manager/app-manager.class';

Vue.config.productionTip = false;

Vue.prototype.$appManager = AppManager.getInstance(store);

new Vue({
    store,
    render: (h) => h(Desk)
}).$mount('#app');
